import React from 'react';
import Icon from '../components/Icon';
export default function PermissionRequired({ t }) {
  return (
    <div className='km__l--permission-required'>
      <div className='km__l--permission-required-message'>
        <Icon size='70' name='alert-triangle' color='#FF5630' />
        <h2>Sayfayı görüntülemek için yetkiniz bulunmamaktadır!</h2>
      </div>
    </div>
  );
}
